import { RefObject, TextareaHTMLAttributes } from 'react';
import { UseControllerProps } from 'react-hook-form';

export const TextareaResize = {
  none: 'none',
  vertical: 'vertical',
  horizontal: 'horizontal',
  both: 'both',
} as const;

export type TextareaResize = (typeof TextareaResize)[keyof typeof TextareaResize];

export type TextAreaProps = Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'size' | 'defaultValue'
> & {
  wrapperId?: string;
  errorMessage?: string;
  description?: string;
  width?: string | number;
  label?: string;
  'aria-label': string;
  name: string;
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  /**
   * Allow the textarea to scale with the text (up to maxHeight)
   */
  stretch?: boolean;
  maxHeight?: string;
  /**
   * Resize control for the textarea
   */
  resize?: TextareaResize;
};

export type TextAreaRhfProps = Omit<TextAreaProps, 'value'> & {
  rules?: UseControllerProps['rules'];
};

export type UseTextareaEventsParams = {
  textareaRef: RefObject<HTMLTextAreaElement>;
  stretch: boolean;
  resize: TextareaResize;
};
